import React from 'react';
import { BinConstraint } from '../types/bin_constraints/binConstraint';

export interface BinConstraintContextProps {
  binConstraints: Map<string, BinConstraint>;
  setBinConstraints: (bins: Map<string, BinConstraint>) => void;
  binConstraintsLoading: boolean;
  validateBinConstraints: (stockLocationId: string, binId: string, pmdId: string) => boolean;
}

const defaultContext: BinConstraintContextProps = {
  binConstraints: new Map(),
  setBinConstraints: () => {},
  binConstraintsLoading: false,
  validateBinConstraints: () => true,
};

export const BinConstraintContext = React.createContext<BinConstraintContextProps>(defaultContext);
